import { intakesAccionesRoles } from '../../acciones-roles/departamentos/intakes-acciones-roles,';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const IntakesRoutes: SideBarButton = {
  data: {
    name: 'Intakes',
    appendUrl: './intakes',
    roles: [...intakesAccionesRoles.sideNavActions.root],
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Reporte',
        url: '/report',
        roles: [...intakesAccionesRoles.sharedActions.report],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Escáner',
        url: '/box',
        roles: [...intakesAccionesRoles.sharedActions.box],
        otherUrls: ['/box/:teamId', '/box/:teamId/:workOrder'],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Agregar pallet',
        url: '/pallet',
        roles: [...intakesAccionesRoles.sharedActions.pallet],
        otherUrls: ['/pallet/:teamId', '/pallet/:teamId/:palletId'],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte pallets',
        url: '/data',
        roles: [...intakesAccionesRoles.sharedActions.data],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Filtros',
        url: '/filter',
        roles: [...intakesAccionesRoles.sharedActions.filter],
        otherUrls: ['/filter/:operatorId', '/filter/:operatorId/:palletId'],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Validacion',
        url: '/validation',
        roles: [...intakesAccionesRoles.sharedActions.validation],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte Power BI',
        overWriteUrl: './reportsPBI/intakes',
        // roles: [...intakesAccionesRoles.sideNavActions.reportsPbiIntakes],
      },
      options: PreConfigButton3,
    },
  ],
};
